module.exports = require("@apollo/client/cache");